var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BlankHeader'),_c('div',{staticClass:"main-page account-pages"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }